<template>
	<Dialog v-model:visible="store.visible" modal :closable="false" :draggable="false" :style="{ width: '30rem' }">
		<template #header>
			<span class="db-connection-error-title">
				<i class="pi pi-database mr-2" />
				Erro de Conexão com o Banco de Dados
			</span>
		</template>

		<div class="db-connection-error-content">
			<i class="pi pi-exclamation-triangle db-connection-error-icon" />
			<p>
				Ocorreu um problema ao tentar se conectar com o banco de dados.
				<br />
				<strong>Por favor, entre em contato com o setor de TI da empresa.</strong>
			</p>
		</div>

		<template #footer>
			<Button label="OK" icon="pi pi-check" autofocus @click="store.hide()" />
		</template>
	</Dialog>
</template>

<script lang="ts" setup>
	import Dialog from "primevue/dialog";
	import Button from "primevue/button";
	import { useDBConnectionError } from "~/composables/useDBConnectionError";

	const store = useDBConnectionError();
</script>

<style scoped>
	.db-connection-error-title {
		display: flex;
		align-items: center;
		color: var(--red-600, #dc2626);
		font-weight: 600;
		font-size: 1.1rem;
	}

	.db-connection-error-content {
		display: flex;
		align-items: flex-start;
		gap: 1rem;
	}

	.db-connection-error-icon {
		font-size: 2rem;
		color: var(--yellow-500, #eab308);
		flex-shrink: 0;
	}
</style>
